var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM12.0303 6.03033C12.3232 5.73744 12.3232 5.26256 12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967L6.5 9.43934L5.03033 7.96967C4.73744 7.67678 4.26256 7.67678 3.96967 7.96967C3.67678 8.26256 3.67678 8.73744 3.96967 9.03033L5.96967 11.0303C6.26256 11.3232 6.73744 11.3232 7.03033 11.0303L12.0303 6.03033Z",
    fill: "#8C9CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDelivered);
export default __webpack_public_path__ + "static/media/status_delivered.d427a9152f13881c9202fdedb158d689.svg";
export { ForwardRef as ReactComponent };